import { render } from "./APKDownloadPageQR.vue?vue&type=template&id=5799bed2&scoped=true"
import script from "./APKDownloadPageQR.vue?vue&type=script&lang=js"
export * from "./APKDownloadPageQR.vue?vue&type=script&lang=js"

import "./APKDownloadPageQR.vue?vue&type=style&index=0&id=5799bed2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5799bed2"]])

export default __exports__